import { render } from "./InteractiveVideo.vue?vue&type=template&id=07de451b&scoped=true"
import script from "./InteractiveVideo.vue?vue&type=script&lang=js"
export * from "./InteractiveVideo.vue?vue&type=script&lang=js"

import "./InteractiveVideo.vue?vue&type=style&index=0&id=07de451b&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07de451b"]])

export default __exports__